import { StatusDot } from 'foundations-components/transitional/components/StatusDot';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CloseDateProgress } from '../../types/api/deals';
import { jsx as _jsx } from "react/jsx-runtime";
const CloseDateCellDecorator = ({
  history
}) => {
  if (!history) {
    return null;
  }
  if (history.hs_close_date_progress === CloseDateProgress.PUSH) {
    return /*#__PURE__*/_jsx(Tooltip, {
      "data-test-id": "close-date-cell-decorator",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "dealTable.propertyChange.closeDatePush"
      }),
      children: /*#__PURE__*/_jsx(StatusDot, {
        "data-test-id": "close-date-cell-status-removed",
        marginInlineEnd: "0",
        use: "removed"
      })
    });
  }
  if (history.hs_created_in_period) {
    return null;
  }
  switch (history.hs_close_date_progress) {
    case CloseDateProgress.REMOVED:
      return /*#__PURE__*/_jsx(Tooltip, {
        "data-test-id": "close-date-cell-decorator",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealTable.propertyChange.closeDateRemoved"
        }),
        children: /*#__PURE__*/_jsx(StatusDot, {
          "data-test-id": "close-date-cell-status-removed",
          use: "removed"
        })
      });
    case CloseDateProgress.NEW:
      return /*#__PURE__*/_jsx(Tooltip, {
        "data-test-id": "close-date-cell-decorator",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealTable.propertyChange.closeDateAdded"
        }),
        children: /*#__PURE__*/_jsx(StatusDot, {
          "data-test-id": "close-date-cell-status-success",
          use: "success"
        })
      });
    case CloseDateProgress.PULL:
      return /*#__PURE__*/_jsx(Tooltip, {
        "data-test-id": "close-date-cell-decorator",
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "dealTable.propertyChange.closeDatePull"
        }),
        children: /*#__PURE__*/_jsx(StatusDot, {
          "data-test-id": "close-date-cell-status-success",
          use: "success"
        })
      });
    default:
      return null;
  }
};
export default CloseDateCellDecorator;